<template>
  <div class="container">
    <van-cell-group>
      <span class="label-where">{{ $t('From') }}</span>
      <AirportSelector :placeholder="$t('From Airport')" @selected="fromAirportChanged"
                       style="margin: 0"></AirportSelector>
    </van-cell-group>
    <van-cell-group>
      <span class="label-where">{{ $t('To') }}</span>
      <AirportSelector :placeholder="$t('To Airport')" @selected="toAirportChanged" style="margin: 0"></AirportSelector>
    </van-cell-group>
    <van-cell-group>
      <van-cell @click="showDatePickup = true" class="select-cell">
        <slot name="title">
          <span>{{ $t('Departing Date') }}</span>
          <span class="departingDate-name">{{ departingDate.name }}</span>
            <van-icon name="arrow-down" slot="right-icon" />
        </slot>
      </van-cell>
    </van-cell-group>

    <van-cell-group>
      <van-cell @click="showTimePickup = true" class="select-cell">
        <slot name="title">
          <span>{{ departingTime.name }}</span>
          <span class="departingDate-name">{{ departingTime.subname }}</span>
            <van-icon name="arrow-down" slot="right-icon" />
        </slot>
      </van-cell>
    </van-cell-group>

    <van-cell-group style="margin: 0 7px 18px;">
      <airline-selector @selected="onAirlineSelected" :clearable="true" :placeholder="$t('Airline (optional)')"
                        maxlength="2"/>
    </van-cell-group>
    <div class="no-result" v-if="noResult">{{ $t('No results to display') }}</div>
    <van-button size="large" type="info" class="button-find-flight" @click="getFlights">{{ $t('Find flights') }}
    </van-button>

    <van-actionsheet
      v-model="showDatePickup"
      :actions="dateList"
      @select="onDateSelected"
    />
    <van-actionsheet
      v-model="showTimePickup"
      :actions="timeList"
      @select="onTimeSelected"
    />
  </div>
</template>

<script>
import AirportSelector from '../components/AirportSelector'
import AirlineSelector from '../components/AirlineSelector'
import { isPrimitive } from 'util'

const langs = ['ru', 'de'] // DD/MM/YY 日期格式的语种
export default {
  name: 'Route',
  components: { AirportSelector, AirlineSelector },
  data () {
    return {
      fromAirport: '',
      toAirport: '',
      airline: '',
      departingDate: null,
      departingTime: null,
      dateList: [],
      timeList: [
        {
          name: this.$t('Before dawn'),
          subname: this.$t('BeforeTime'),
          time: '0 ~ 6'
        },
        {
          name: this.$t('Morning'),
          subname: this.$t('MorningTime'),
          className: 'selectedDate',
          time: '6 ~ 11'
        },
        {
          name: this.$t('Noon'),
          subname: this.$t('NoonTime'),
          time: '11 ~ 13'
        },
        {
          name: this.$t('Afternoon'),
          subname: this.$t('AfternoonTime'),
          time: '13 ~ 18'
        },
        {
          name: this.$t('Evening'),
          subname: this.$t('EveningTime'),
          time: '18 ~ 24'
        }
      ],
      showDatePickup: false,
      showTimePickup: false,
      noResult: false
    }
  },
  computed: {
    flights () {
      return this.flightList.filter(f => {
        if (this.airline.length > 0) {
          return f.FlightNo.toUpperCase().startsWith(this.airline.toUpperCase())
        }
        return true
      })
    }
  },
  watch: {
    departingDate (val) {
      for (let key in this.dateList) {
        if (val.name == this.dateList[key].name) {
          for (let i in this.dateList) {
            this.dateList[i].className = ''
          }
          this.dateList[key].className = 'selectedDate'
        }
      }
    },
    departingTime (val) {
      for (let key in this.timeList) {
        if (val.name == this.timeList[key].name) {
          for (let i in this.timeList) {
            this.timeList[i].className = ''
          }
          this.timeList[key].className = 'selectedDate'
        }
      }
    }
  },
  created () {
    this.formatDate()
    this.getNowTime()
  },
  methods: {
    formatDate() {
      let formatRule = 'DD-MM-YYYY'
      if (langs.indexOf(localStorage.getItem('lang')) !== -1) {
        formatRule = 'DD/MM/YYYY'
      }
      this.departingDate = {
        name: this.$t('Today'),
        subname: this.$moment().format(formatRule)
      }
      this.dateList = [
        {
          name: this.$t('Yesterday'),
          subname: this.$moment().add(-1, 'day').format(formatRule)
        },
        {
          name: this.$t('Today'),
          subname: this.$moment().format(formatRule),
          className: 'selectedDate'
        },
        {
          name: this.$t('Tomorrow'),
          subname: this.$moment().add(1, 'days').format(formatRule)
        },
        {
          name: this.$t('Day after tomorrow'),
          subname: this.$moment().add(2, 'days').format(formatRule)
        }
      ]
    },
    fromAirportChanged (airport) {
      this.fromAirport = airport.code
    },
    toAirportChanged (airport) {
      this.toAirport = airport.code
    },
    onDateSelected (date) {
      this.departingDate = date
      this.showDatePickup = false
    },
    onTimeSelected (time) {
      this.departingTime = time
      this.showTimePickup = false
    },
    onAirlineSelected (airline) {
      if (airline && airline.code) {
        this.airline = airline.code
      } else {
        this.airline = ''
      }
    },
    getFlights () {
      let dep = this.fromAirport
      let arr = this.toAirport
      let datastr = this.departingDate.subname;
      if (langs.indexOf(localStorage.getItem('lang')) !== -1) {
        datastr = datastr.split('/');
      } else {
        datastr = datastr.split('-');
      }
      let date = `${datastr[2]}-${datastr[1]}-${datastr[0]}`
      let [starthour, endhour] = this.departingTime.time.split('~').map(i => i.trim())
      let url = this.$urlHelper.byRoute(dep, arr, date, starthour, endhour)
      this.$http.get(url).then(response => {
        if (response.status === 200 && !response.data.error) {
          this.noResult = false
          this.$gtm.push({
            'event': 'screenview',
            'site_type': sessionStorage.getItem('site_type'),
            'brand': 'edreams',
            'screenName': '/flights-tracker/route/results',
            'lang': localStorage.getItem('cod_lang') || localStorage.getItem('lang'),
            'cid': localStorage.getItem('cid')
          })
          if (response.data.length === 1) {
            let fnum = response.data[0].FlightNo
            let date = this.$moment(response.data[0].FlightDeptimePlanDate).format('YYYY-MM-DD')
            let dep = response.data[0].FlightDepcode
            let arr = response.data[0].FlightArrcode
            this.$store.state.flight = response.data[0]
            this.$store.commit('setFlight', response.data[0])
            this.$router.push(`/flight?fnum=${fnum}&dep=${dep}&arr=${arr}&date=${date}&cid=${localStorage.getItem('cid')}`)
            return
          }
          let searchProps = {
            date: this.departingDate.subname,
            from: this.fromAirport,
            to: this.toAirport,
            time: this.departingTime.name
          }
          sessionStorage.setItem('searchProps', JSON.stringify(searchProps))
          sessionStorage.setItem('flightList', JSON.stringify(response.data))
          sessionStorage.setItem('searchType', 'route')
          this.$router.push('/SearchList')
        } else {
          this.noResult = true
        }
      })
    },

    getNowTime () {
      let hour = new Date().getHours()
      let minutes = new Date().getMinutes()
      if (minutes > 0) {
        hour = hour + 1
      }
      let num = 0
      if (hour <= 6) {
        num = 0
      } else if (hour <= 11) {
        num = 1
      } else if (hour <= 13) {
        num = 2
      } else if (hour <= 18) {
        num = 3
      } else {
        num = 4
      }
      this.departingTime = this.timeList[num]
    }
  }
}
</script>

<style scoped>
  .label-where {
    padding: 0 8px;
    font-size: 11px;
    color: #999;
  }

  .van-actionsheet__item {
    text-align: left;
    margin: 0 10px;
    border-bottom: 1px solid #d8d8d8;
  }

  .van-actionsheet__item:last-child {
    border-bottom: 0;
  }

  .selectedDate {
    color: #90A9B9;
  }

  .van-hairline--top-bottom::after {
    border-width: 0;
  }

  .selectedDate .van-actionsheet__subname {
    color: #90A9B9;
  }

  .van-cell {
    padding: 0px 15px 0px 8px;
    font-size: 16px;
  }

  .departingDate-name {
    color: #7d7e80;
    font-size: 12px;
    margin-left: 5px;
  }

  .van-cell__value--alone {
    font-size: 16px;
    color: #433f33;
  }

.van-icon-arrow-down {
  line-height: 25px;
  color: #999;
}

.no-result {
    line-height: 50px;
    text-align: center;
    font-size: 13px;
    color: #969799;
  }
</style>
